import { render, staticRenderFns } from "./IntervenePlanTumor.vue?vue&type=template&id=026d97bf&scoped=true"
import script from "./IntervenePlanTumor.vue?vue&type=script&lang=js"
export * from "./IntervenePlanTumor.vue?vue&type=script&lang=js"
import style0 from "./IntervenePlanTumor.vue?vue&type=style&index=0&id=026d97bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d97bf",
  null
  
)

export default component.exports